import Vue from 'vue'


import router from './router'
import store from './store/index'
import axios from 'axios'

import VueNotification from 'vue-notification'
import VeeValidate from 'vee-validate'

//Custom Elements
import Loading from './elements/Loading.vue'

import LoadingButton from './elements/LoadingButton'
import Modal from './elements/Modal'
import ConfirmModal from './elements/ConfirmModal'
import Timestamp from './elements/Timestamp'
import Number from './elements/Number'
import Money from './elements/Money'
import DropdownButton from './elements/DropdownButton'
import DropdownSelection from './elements/DropdownSelection'
import DropdownSelectionSlotted from './elements/DropdownSelectionSlotted'

//Custom Layouts
import AppLayout from './layouts/AppLayout'

import NoLayout from './layouts/NoLayout'
import SideMenuLayout from './layouts/SideMenuLayout'
import ScrollablePageLayout from './layouts/ScrollablePageLayout'
import App from './App.vue'

//https://github.com/mariomka/vue-datetime
import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

import SecurityUtil from "./util/SecurityUtil";

Vue.config.productionTip = false;

Vue.use(VueNotification);

Vue.use(VeeValidate, {
    fieldsBagName : 'vvFields',
    dictionary : {
        en : {
            custom : {
                password_confirm : {
                    required : 'You must confirm your new password',
                    confirmed : 'Your passwords do not match!'
                },
            }
        }
    }
});

// Register Custom Elements
Vue.component('loading', Loading);
Vue.component('loading-button', LoadingButton);
Vue.component('modal', Modal);
Vue.component('confirm-modal', ConfirmModal);
Vue.component('timestamp', Timestamp);
Vue.component('number', Number);
Vue.component('money', Money);
Vue.component('dropdown-button', DropdownButton);
Vue.component('dropdown-selection', DropdownSelection);
Vue.component('dropdown-selection-slotted', DropdownSelectionSlotted);

import DocumentTitle from './components/DocumentTitle';
Vue.component('DocumentTitle', DocumentTitle);

import ContainedPageLayout from "./layouts/ContainedPageLayout";
// Register Custom Layouts
Vue.component('AppLayout', AppLayout);
Vue.component('NoLayout', NoLayout);
Vue.component('ScrollablePageLayout', ScrollablePageLayout);
Vue.component('SideMenuLayout', SideMenuLayout);
Vue.component('ContainedPageLayout', ContainedPageLayout);


import uniqid from 'uniqid';

Vue.prototype.$uniqueId = (obj, propName = 'uniqueId') => {
    if(obj === undefined){
        return uniqid();
    }
    if(obj[propName]){
        return obj[propName];
    }
    obj[propName] = uniqid();
    return obj[propName];
};

Vue.prototype.$deepCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}

Vue.prototype.$srcOverwrite = (src) => {
    if(!src){
        return src;
    }else{
        return src.replace('dmx-assets-cloudfront.s3.amazonaws.com','assets.flxpoint.com')
            .replace('dev-dmx-assets.s3.amazonaws.com','dev-assets.flxpoint.com');
    }
};

axios.defaults.headers.common['X-CLIENT-HOST'] = window.location.href;
SecurityUtil.setAxiosToken();

Vue.prototype.$getSessionContext = () => {
    return store.state.session_context;
};

Vue.prototype.$getDealer = () => {
    return store.state.session_context ? store.state.session_context.dealer : null;
};

Vue.prototype.$getAccount = () => {
    return store.state.session_context ? store.state.session_context.account : null;
};

Vue.prototype.$isProdEnv = () => {
    return process.env.NODE_ENV.includes("production");
};

Vue.prototype.$notifySuccess = (text) => {
    Vue.notify({
        text : text,
        type : 'success',
    });
};

Vue.prototype.$notifyWarn = (text) => {
    Vue.notify({
        text : text,
        type : 'warn',
    });
};

Vue.prototype.$notifyError = (text) => {
    Vue.notify({
        text : text,
        type : 'error',
    });
};

Vue.use(Datetime);

new Vue({
    router,
    store,
    render : h => h(App)
}).$mount('#app')
